import { createFileRoute } from "@tanstack/react-router";

const Name = () => {
    return <div>Name</div>;
};

export const Route = createFileRoute("/_app/foot-watch/$diaryId/edit/name")({
    component: Name,
});
